import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from "@angular/core";

@Component({
  selector: "[wall-type-9]",
  templateUrl: "./wall-type-9.component.html",
  styleUrls: ["./wall-type-9.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WallType9Component {
  height = input<number>();

  leftWallPoints = computed(() => this.getWallPoints(this.height(), "left"));
  rightWallPoints = computed(() => this.getWallPoints(this.height(), "right"));

  // Warehouse
  private getWallPoints(baseHeight: number, wallSide: "left" | "right"): string {
    const wallData = {
        left: `M0.5 70 L115 139 L115 ${baseHeight + 80} L0.5 ${baseHeight + 15} V70 Z`,
        right: `M231 ${baseHeight + 15} L116 ${baseHeight + 80} L116 139 L231 70 V${baseHeight + 15} Z`
    };

    return wallData[wallSide];
  }
}
